var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "root" },
    [
      _vm.isLoading
        ? _c("LoadingSpinner", { attrs: { size: "medium", variant: "inline" } })
        : _vm.loadFailed
        ? _c("p", { staticClass: "load-error", attrs: { role: "alert" } }, [
            _vm._v(_vm._s(_vm.$t("eventContest.error.fetchFailed"))),
          ])
        : _vm.contest
        ? _c("article", { staticClass: "panel" }, [
            _vm.imageUrl
              ? _c("img", {
                  staticClass: "hero",
                  attrs: { src: _vm.imageUrl, alt: _vm.contestTitle },
                })
              : _vm._e(),
            _c("div", { staticClass: "body" }, [
              _c("h1", { staticClass: "title" }, [
                _vm._v(_vm._s(_vm.$t("eventContestTerms.title"))),
              ]),
              _vm.termsHtml
                ? _c("div", {
                    staticClass: "content",
                    domProps: { innerHTML: _vm._s(_vm.termsHtml) },
                  })
                : _vm._e(),
              _c("p", { staticClass: "consent-note" }, [
                _vm._v(_vm._s(_vm.$t("eventContestTerms.minorConsent"))),
              ]),
              _c(
                "button",
                {
                  staticClass: "agree-button",
                  attrs: { type: "button", disabled: !_vm.canApply },
                  on: { click: _vm.onClickAgree },
                },
                [
                  _vm._v(
                    " " + _vm._s(_vm.$t("eventContestTerms.agreeButton")) + " "
                  ),
                ]
              ),
            ]),
          ])
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }